import { BaseRequest } from '@/network/requests/BaseRequest'
import { tech_info } from '@/interfaces/tech_info'
import { PageQuery } from '@/network/interfaces/PageQuery'

export const techInfoRequest = BaseRequest.build<tech_info>('tech_info')

export function queryTechs(page: number, pagesize: number, nameSearch = '') {
	const query: PageQuery = {
		page,
		pagesize,
	}
	if (nameSearch) {
		query.filter = {
			name: { $regex: nameSearch },
		}
	}
	return techInfoRequest.queryPage(query)
}

export function queryTechByIdList(techIds: string[]) {
	return techInfoRequest.queryAll({
		_id: { $in: techIds.map(id => ({ $oid: id })) },
	})
}

export function SaveTech(model: tech_info) {
	if (model._id) {
		if (model._id.$oid) {
			return techInfoRequest.modifyById(model._id.$oid, model)
		}
	}

	return techInfoRequest.upload(model)
}

/**
 * 获取所有的工艺参数。
 */
export function getAllTech() {
	return techInfoRequest.queryAll()
}

/**
 * 删除工艺参数。
 * @param id
 */
export function DeleteTech(id) {
	if (!id) return

	return techInfoRequest.deleteById(id)
}
